import { createFeatureSelector, createSelector } from '@ngrx/store';

const getPortalState = createFeatureSelector('PORTAL_STORE');

export const getFocusSlice = createSelector(
  getPortalState,
  (state: any) => state.focus,
);

export const getFocusLoadedStatus = createSelector(
  getFocusSlice,
  (state: any) => state.loaded,
);

export const getFocusData = createSelector(
  getFocusSlice,
  (state: any) => state.focusData,
);
